import ToastPopup from 'components/molecules/ToastPopup';
import React, { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';
import { TOAST_VERSION_2 } from 'utils/constants/toasts';
import PermissionUtils from 'utils/permission-utils';
import { removeToast } from '../../store/actions/toasts';
import FullScreenPortal from './FullScreenPortal';

function Toast({ toast, time }) {
    const dispatch = useDispatch();

    if (toast.duration) {
        time = toast.duration;
    }
    if (time === 'forever') time = 1000000;
    if (!time) time = 5000;

    useEffect(() => {
        const timeOut = setTimeout(() => {
            dispatch(removeToast(toast.id));
        }, time);

        return () => clearTimeout(timeOut);
    }, [toast.id, dispatch, time]);

    if (!toast?.message) {
        return null;
    }

    return toast.message ? (
        <li className='am-toast'>
            <div
                className={`alert alert-${toast.type} alert-dismissible fade show`}
                role='alert'
            >
                <span>
                    {toast?.message?.component
                        ? toast.message.component
                        : ReactHtmlParser(
                              toast.message.markup || toast.message
                          )}
                </span>
                {toast.closeButton && (
                    <button
                        type='button'
                        className='close'
                        data-dismiss='alert'
                        aria-label='Close'
                        onClick={() => dispatch(removeToast(toast.id))}
                    >
                        <span aria-hidden='true'>&times;</span>
                    </button>
                )}
            </div>
        </li>
    ) : null;
}

function Toasts() {
    const toasts = useSelector((state) => state.toasts);

    if (PermissionUtils.isEventCloudHost()) {
        return null;
    }

    return (
        <>
            <FullScreenPortal>
                <ul className='toasts'>
                    {toasts.map((toast) =>
                        toast.version === TOAST_VERSION_2 ? null : (
                            <Toast toast={toast} key={toast.id} />
                        )
                    )}
                </ul>
            </FullScreenPortal>
            {toasts.map((toast) =>
                toast.version === TOAST_VERSION_2 ? (
                    <ToastPopup key={toast.id} {...{ ...toast, show: true }} />
                ) : null
            )}
        </>
    );
}

export default Toasts;
